import querystring from 'querystring';
import { AxiosResponse } from 'axios';

import { getStoreProxyUrl } from '../index';
import { IResponse } from '../types';
import {
    IDeletePassengerApiRequest,
    IFutureLine,
    IGetFutureLinesRequest,
    IPassengerRequest,
    IPassengerResponse,
    IResponseAddOrUpdatePassenger,
    ISetPassengerRequest,
} from './types';
import { createPayload, postProxy } from '../utilis';

// FC REQUEST

export const getPassengers = ({
    proxyUrl,
    dbUrl,
    ...payload
}: IPassengerRequest): Promise<AxiosResponse<IPassengerResponse>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_Passengers_Details',
    });

    return postProxy<IPassengerResponse>(getStoreProxyUrl(), data);
};

// FC REQUEST

export const GetFutureLines = ({
    proxyUrl,
    dbUrl,
    ...payload
}: IGetFutureLinesRequest): Promise<AxiosResponse<IResponse<IFutureLine[]>>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_Future_Lines',
    });

    return postProxy<IResponse<IFutureLine[]>>(getStoreProxyUrl(), data);
};

// FC REQUEST

export const deletePassenger = async ({
    proxyUrl,
    dbUrl,
    ...payload
}: IDeletePassengerApiRequest): Promise<AxiosResponse<IResponse<void>>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Del_Passengers',
    });

    return postProxy<IResponse<void>>(getStoreProxyUrl(), data);
};

// FC REQUEST

export const addOrUpdatePassenger = async ({
    proxyUrl,
    dbUrl,
    ...payload
}: ISetPassengerRequest): Promise<AxiosResponse<IResponseAddOrUpdatePassenger>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Set_Passenger',
    });

    return postProxy<IResponseAddOrUpdatePassenger>(getStoreProxyUrl(), data);
};
